export const PACKAGE_UNITS = ['case', 'box', 'bag', 'pack', 'bottle', 'can', 'jar', 'tray', 'pallet', 'bucket', 'drum', 'each'] as const;
export const INVENTORY_UNITS = ['each', 'unit', 'piece', 'lb', 'oz', 'kg', 'g', 'gallon', 'quart', 'pint', 'fl oz', 'liter', 'ml'] as const;

export type PackageUnit = typeof PACKAGE_UNITS[number];
export type InventoryUnit = typeof INVENTORY_UNITS[number];

const labels: Record<string, { en: string; es: string }> = {
  case: { en: 'Case', es: 'Caja (case)' }, box: { en: 'Box', es: 'Caja (box)' }, bag: { en: 'Bag', es: 'Bolsa' },
  pack: { en: 'Pack', es: 'Paquete' }, bottle: { en: 'Bottle', es: 'Botella' }, can: { en: 'Can', es: 'Lata' },
  jar: { en: 'Jar', es: 'Frasco' }, tray: { en: 'Tray', es: 'Bandeja' }, pallet: { en: 'Pallet', es: 'Paleta' },
  bucket: { en: 'Bucket', es: 'Cubeta' }, drum: { en: 'Drum', es: 'Tambor' }, each: { en: 'Each', es: 'Unidad' },
  unit: { en: 'Unit', es: 'Unidad' }, piece: { en: 'Piece', es: 'Pieza' }, lb: { en: 'Pound (lb)', es: 'Libra (lb)' },
  oz: { en: 'Ounce (oz)', es: 'Onza (oz)' }, kg: { en: 'Kilogram (kg)', es: 'Kilogramo (kg)' }, g: { en: 'Gram (g)', es: 'Gramo (g)' },
  gallon: { en: 'US gallon', es: 'Galón EE. UU.' }, quart: { en: 'US quart', es: 'Cuarto de galón EE. UU.' }, pint: { en: 'US pint', es: 'Pinta EE. UU.' },
  'fl oz': { en: 'US fluid ounce (fl oz)', es: 'Onza líquida EE. UU. (fl oz)' }, liter: { en: 'Liter', es: 'Litro' }, ml: { en: 'Milliliter', es: 'Mililitro' },
};

export function unitLabel(value: string, locale: 'en' | 'es') {
  return labels[value]?.[locale] || value;
}
